import type {
  SubscriptionResponse,
  AutoRenewalDeactivationCondition,
  SubscriptionOfferQuery,
} from "~/generated/graphql";

export const getAutoRenewalPolicy = (
  offer?:
    | SubscriptionResponse
    | SubscriptionOfferQuery["subscriptionOfferById"],
): AutoRenewalDeactivationCondition | undefined => {
  return offer?.catalogueOffer?.plan.membershipTier.policies.autoRenewalPolicy
    .deactivationConditions[0];
};
